import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    title: 'SHOT BAND',
    loading: 'Loading SHOT BAND...',

    // BandHero — member
    heroWelcome: 'Welcome to',
    heroMemberBadge: 'SHOT BAND member',
    heroDaysLeftOne: '{{count}} day left',
    heroDaysLeftFew: '{{count}} days left',
    heroDaysLeftMany: '{{count}} days left',
    heroDaysLeftZero: 'Membership ends today',
    heroRenewButton: 'Renew',
    // BandHero — non-member
    heroOfferTitlePrefix: 'The',
    heroOfferTitleSuffix: 'top-up turns the club on — here or in any top-up.',
    heroOfferBody: 'Cashback up to 4% — it grows with your level — daily quests and a shot at the knife raffle.',
    heroOfferFinePrint: 'The whole amount lands on your game balance. Spend it on cases, contracts, games and upgrades however you like.',
    heroJoinButton: 'Join for',
    heroHowItWorks: 'How it works',

    // BandRulesSheet
    rulesTitle: 'How SHOT BAND works',
    rule1Prefix: 'Top up',
    rule1Suffix: "in one payment — you're in SHOT BAND for 28 days. The coins land on your balance as usual.",
    rule1Title: 'Joining SHOT BAND',
    rule2Title: 'Cashback up to 4%',
    rule2: 'Every coin game pays cashback back in sparks. The rate grows with your level — 1% at level 10, 4% at level 100. Claim it every 7 days.',
    rule3Title: 'Cases for sparks',
    rule3Prefix: 'Sparks',
    rule3Suffix: 'open SHOT BAND cases — skins all the way up to knives.',
    rule4Title: 'Quests and streak',
    rule4Prefix: 'Daily quests earn',
    rule4Mid: '. Keep a 7-day streak — get +10',
    rule4Suffix: 'as a bonus.',
    rule5Title: 'Weekly knife raffle',
    rule5Prefix: 'Every week we raffle a knife. Invest your',
    rule5Suffix: '— more tickets, higher chance.',
    rule6Title: 'Daily race',
    rule6: 'Wager the most coins before midnight (MSK) and take the day’s skin. Every day, a new prize.',
    rule7Title: 'Free cases for turnover',
    rule7: 'Your daily turnover opens shelf cases for free — the more you play, the richer the free case. Up to every case, every day.',

    // BandTicketSheet
    ticketSheetTitleJoin: 'Join SHOT BAND',
    ticketSheetTitleRenew: 'Renew SHOT BAND',
    ticketSheetTopupNotePrefix: 'Your balance is credited with',
    ticketSheetTopupNoteSuffix: 'right away — the club comes as a gift.',
    ticketSheetRenewDisclaimer: 'Renewal adds 28 days to your current membership term.',
    ticketSheetBuyButton: 'Pay',
    ticketSheetLoadingProviders: 'Loading payment methods...',
    ticketSheetNoProviders: 'No payment methods available right now.',
    ticketSheetErrorGeneric: 'Failed to create the invoice. Try again.',
    ticketSheetLoadErrorGeneric: 'Failed to load payment methods.',
    ticketSheetPriceUnavailable: 'Price unavailable for this payment method — try another one.',
    ticketSheetCardConfirmTitle: 'Confirm payment',
    ticketSheetCardConfirmMessage: 'Charge {{amount}} from {{card}} to join SHOT BAND?',
    ticketSheetCardConfirmOk: 'Pay',
    ticketSheetCardPending: 'Click is still confirming the payment — your membership will switch on automatically.',
    ticketSheetCardErrorGeneric: 'The payment did not go through. Try again.',

    // BandCashback
    cashbackBalanceLabel: 'Club balance',
    cashbackCoinsLabel: 'Sparks',
    cashbackTicketsLabel: 'Tickets',
    cashbackNextPayoutLabel: 'Next payout:',
    mechanicNameCase: 'Cases',
    mechanicNameBattle: 'Battles',
    mechanicNameRushMid: 'Rush Mid',
    mechanicNameRoulette: 'Roulette',
    mechanicNameUpgrade: 'Upgrades',
    mechanicNameContract: 'Contracts',
    cashbackChipPrefix: 'cashback',
    cashbackChipLocked: 'cashback from lvl {{level}}',
    cashbackSpendButton: 'Spend',
    cashbackInvestButton: 'Invest',
    cashbackClaimReadyLabel: 'Cashback ready:',
    cashbackClaimButton: 'Claim',
    cashbackTimerLabel: 'in',
    cashbackUnitDay: 'd',

    // BandStreak
    streakDayLabel: 'Day {{day}} of 7',
    streakHint: 'Complete at least one quest a day for {{days}} days in a row — bonus +',

    // BandShelfTeaser
    shelfTeaserTitle: 'SHOT BAND cases',
    shelfTeaserAllCasesButton: 'All cases',

    // BandFreeCases
    freeCasesTitle: 'Free case',
    freeCasesTurnoverLabel: 'Turnover today',
    freeCasesNextHintPrefix: 'Wager',
    freeCasesNextHintSuffix: "more and you'll open it for free",
    freeCasesReadyHint: 'Free to open — go!',
    freeCasesAllClaimed: 'All free opens for today are spent — new ones after the reset',
    freeCasesTimerBurnOpen: 'The free open burns at the reset',
    freeCasesTimerBurnProgress: 'Turnover progress burns at the reset',
    freeCasesTimerPlain: 'Day resets in',
    freeCasesTimerNew: 'New free opens in',
    freeCasesOpenFreeButton: 'Open',
    freeCasesRulesTitle: 'Free case rules',
    freeCasesRulesWagerTitle: 'Play for coins',
    freeCasesRulesWagerBody: 'Every coin game counts into your daily turnover — cases, battles, upgrades, contracts, Rush Mid, roulette.',
    freeCasesRulesOpenTitle: 'Reach the threshold — open for free',
    freeCasesRulesOpenBody: 'Each case has its own turnover threshold. Reached it — the club pays for the open. One free open per case per day.',
    freeCasesRulesResetTitle: 'Everything burns at midnight',
    freeCasesRulesResetBody: 'At midnight (MSK) the day resets: turnover progress and unclaimed free opens burn. Next day — from zero.',

    // BandQuests
    questsTitle: 'Daily quests',
    questsResetLabel: 'New quests in',
    questClaimButton: 'Claim',
    questsLockedJoinButton: 'Join',
    questGenericTitle: 'Daily quest',
    questCompletedToastOverline: 'Quest complete!',
    questGenericUnit: '',

    quest_open_3_cases_2500_prefix: 'Open 3 cases worth',
    quest_open_3_cases_2500_suffix: 'or more',
    quest_open_3_cases_2500_unit: 'cases',
    quest_rush_3_matches_prefix: 'Play 3 Rush Mid matches',
    quest_rush_3_matches_unit: 'matches',
    quest_open_band_case_prefix: 'Open a SHOT BAND case',
    quest_open_band_case_unit: 'case',
    quest_wager_25k_prefix: 'Wager',
    quest_wager_25k_suffix: '',
    quest_battles_2_5k_prefix: 'Play 2 case battles with an entry of',
    quest_battles_2_5k_suffix: 'or more',
    quest_battles_2_5k_unit: 'battles',
    quest_upgrades_3_2500_prefix: 'Make 3 upgrades worth',
    quest_upgrades_3_2500_suffix: 'or more',
    quest_upgrades_3_2500_unit: 'upgrades',
    quest_contract_10k_prefix: 'Complete a contract worth',
    quest_contract_10k_suffix: 'or more',
    quest_contract_10k_unit: 'contract',
    quest_win_battle_prefix: 'Win a case battle',
    quest_win_battle_unit: 'battle',
    quest_win_upgrade_prefix: 'Win an upgrade',
    quest_win_upgrade_unit: 'upgrade',
    quest_open_case_12500_prefix: 'Open a case worth',
    quest_open_case_12500_suffix: 'or more',
    quest_open_case_12500_unit: 'case',
    quest_open_5_cases_1000_prefix: 'Open 5 cases worth',
    quest_open_5_cases_1000_suffix: 'or more',
    quest_open_5_cases_1000_unit: 'cases',
    quest_roulette_play_prefix: 'Play a roulette round',
    quest_roulette_play_unit: 'round',
    quest_contracts_25k_sum_prefix: 'Complete contracts worth',
    quest_contracts_25k_sum_suffix: 'in total',
    quest_upgrades_15k_sum_prefix: 'Make upgrades worth',
    quest_upgrades_15k_sum_suffix: 'in total',
    quest_rush_5_matches_prefix: 'Play 5 Rush Mid matches',
    quest_rush_5_matches_unit: 'matches',
    quest_wager_50k_prefix: 'Wager',
    quest_wager_50k_suffix: '',
    quest_wager_10k_battles_prefix: 'Wager',
    quest_wager_10k_battles_suffix: 'in case battles',
    quest_wager_10k_rush_prefix: 'Wager',
    quest_wager_10k_rush_suffix: 'in Rush Mid',
    quest_wager_10k_roulette_prefix: 'Wager',
    quest_wager_10k_roulette_suffix: 'in roulette',
    quest_wager_100k_prefix: 'Wager',
    quest_wager_100k_suffix: '',
    quest_rush_mid_win_prefix: 'Win a Rush Mid match',
    quest_rush_mid_win_unit: 'win',
    quest_big_drop_25k_prefix: 'Drop an item worth over',
    quest_big_drop_25k_suffix: 'from a case',
    quest_big_drop_25k_unit: 'item',
    quest_risky_upgrade_35_prefix: 'Win an upgrade with odds of 35% or lower',
    quest_risky_upgrade_35_unit: 'upgrade',
    quest_covert_drop_prefix: 'Drop a Covert item from a case',
    quest_covert_drop_unit: 'item',

    // BandRaceSection
    raceTitle: 'Daily race',
    raceEmpty: 'No race today — check back later',
    rulesLinkLabel: 'Rules',
    raceRulesTitle: 'Daily race rules',
    raceRulesPlayTitle: 'How to win',
    raceRulesPlayBody: 'Play anything on SHOT — cases, upgrades, contracts, battles, Rush Mid, roulette. The coins you spend on games count: the biggest daily turnover wins.',
    raceRulesPrizeTitle: 'The prize',
    raceRulesPrizeBody: 'A new skin every day. At midnight (MSK) it goes to the #1 player and lands straight in their inventory.',
    raceRulesMembersTitle: 'Members only',
    raceRulesMembersBody: 'The race is for SHOT BAND members. Your play counts automatically — nothing to activate.',
    raffleRulesTitle: 'Weekly raffle rules',
    raffleRulesTicketsTitle: 'Earn tickets',
    raffleRulesTicketsBodyPrefix: 'Complete daily quests to earn raffle tickets',
    raffleRulesTicketsBodySuffix: '',
    raffleRulesChanceTitle: 'Invest to raise your chance',
    raffleRulesChanceBody: 'Invest tickets into the round — the more you invest, the higher your chance. Invested tickets are not returned, adding more is always allowed.',
    raffleRulesFinalTitle: 'The final',
    raffleRulesFinalBody: 'The round runs for a week. The winner is drawn at random and the skin lands straight in their inventory.',
    racePrizeLabel: "Today's prize",
    raceYourPlace: 'Your place',
    raceParticipantsLabel: 'Playing',
    raceNotWagered: 'Play anything today to join the race',

    // BandRaffleSection
    raffleTitle: 'Weekly raffle',
    raffleEmpty: 'No raffle running this week',
    raffleMyInvestedLabel: 'Invested',
    raffleParticipantsLabel: 'Playing',
    raffleParticipantOne: 'participant',
    raffleParticipantFew: 'participants',
    raffleParticipantMany: 'participants',
    raffleInvestButton: 'Invest',
    raffleEndedButton: 'Round ended',
    raffleWinnersLink: 'Winners',

    // BandInvestSheet
    investSheetTitle: 'Invest in the raffle',
    investSheetLockedBody: 'Join SHOT BAND to invest in the weekly raffle.',
    investSheetJoinButton: 'Join',
    investSheetEndedBody: 'This round has ended — wait for the next one.',
    investSheetNoBalanceBody: 'Nothing to invest yet — complete daily quests to earn some.',
    investSheetDecrease: 'Decrease',
    investSheetIncrease: 'Increase',
    investSheetBalanceHint: '{{balance}} available',
    investSheetDisclaimer: 'Invested amounts are not returned — you can always add more.',
    investSheetErrorGeneric: 'Failed to invest. Try again.',
    investSheetSubmitButton: 'Invest',
  },
  ru: {
    title: 'SHOT BAND',
    loading: 'Загрузка SHOT BAND...',

    heroWelcome: 'Добро пожаловать в',
    heroMemberBadge: 'Ты в SHOT BAND',
    heroDaysLeftOne: 'Остался {{count}} день',
    heroDaysLeftFew: 'Осталось {{count}} дня',
    heroDaysLeftMany: 'Осталось {{count}} дней',
    heroDaysLeftZero: 'Членство заканчивается сегодня',
    heroRenewButton: 'Продлить',
    heroOfferTitlePrefix: 'Пополнение на',
    heroOfferTitleSuffix: 'включает клуб — здесь или в обычном пополнении.',
    heroOfferBody: 'Кешбэк до 4% — растёт с уровнем, ежедневные задания и шанс выиграть нож в розыгрыше.',
    heroOfferFinePrint: 'Вся сумма зачислится на твой игровой баланс. Ты сможешь тратить её на кейсы, контракты, игры и апгрейды как захочешь.',
    heroJoinButton: 'Вступить за',
    heroHowItWorks: 'Как это работает',

    rulesTitle: 'Как работает SHOT BAND',
    rule1Prefix: 'Закинь',
    rule1Suffix: 'одним платежом — ты в SHOT BAND на 28 дней. Монеты придут на твой баланс, как обычно.',
    rule1Title: 'Вход в SHOT BAND',
    rule2Title: 'Кешбэк до 4%',
    rule2: 'Каждая игра за монеты возвращает кешбэк искрами. Процент растёт с уровнем — 1% на 10-м, 4% на 100-м. Забирай каждые 7 дней.',
    rule3Title: 'Кейсы за искры',
    rule3Prefix: 'Искры',
    rule3Suffix: 'открывают кейсы SHOT BAND — внутри скины вплоть до ножей.',
    rule4Title: 'Задания и стрик',
    rule4Prefix: 'Ежедневные задания приносят',
    rule4Mid: '. Держи стрик 7 дней — получишь +10',
    rule4Suffix: 'бонусом.',
    rule5Title: 'Розыгрыш ножа',
    rule5Prefix: 'Каждую неделю разыгрываем нож. Вкладывай',
    rule5Suffix: '— чем больше билетов, тем выше шанс.',
    rule6Title: 'Гонка дня',
    rule6: 'Наиграй за монеты больше всех до полуночи мск — и скин дня твой. Каждый день новый приз.',
    rule7Title: 'Кейсы бесплатно за оборот',
    rule7: 'Дневной оборот открывает кейсы полки бесплатно — чем больше играешь, тем дороже фри-кейс. Хоть все кейсы, хоть каждый день.',

    ticketSheetTitleJoin: 'Вступление в SHOT BAND',
    ticketSheetTitleRenew: 'Продление SHOT BAND',
    ticketSheetTopupNotePrefix: 'На баланс сразу зачислится',
    ticketSheetTopupNoteSuffix: '— клуб идёт подарком.',
    ticketSheetRenewDisclaimer: 'Продление добавится к текущему сроку членства — плюс 28 дней.',
    ticketSheetBuyButton: 'Оплатить',
    ticketSheetLoadingProviders: 'Загружаем способы оплаты...',
    ticketSheetNoProviders: 'Сейчас нет доступных способов оплаты.',
    ticketSheetErrorGeneric: 'Не удалось создать счёт. Попробуй ещё раз.',
    ticketSheetLoadErrorGeneric: 'Не удалось загрузить способы оплаты.',
    ticketSheetPriceUnavailable: 'Цена недоступна для этого способа — выбери другой.',
    ticketSheetCardConfirmTitle: 'Подтверди оплату',
    ticketSheetCardConfirmMessage: 'Списать {{amount}} с карты {{card}} за пропуск в SHOT BAND?',
    ticketSheetCardConfirmOk: 'Оплатить',
    ticketSheetCardPending: 'Click ещё подтверждает платёж — членство включится автоматически.',
    ticketSheetCardErrorGeneric: 'Оплата не прошла. Попробуй ещё раз.',

    cashbackBalanceLabel: 'Баланс клуба',
    cashbackCoinsLabel: 'Искры',
    cashbackTicketsLabel: 'Билеты',
    cashbackNextPayoutLabel: 'Следующая выплата:',
    mechanicNameCase: 'Кейсы',
    mechanicNameBattle: 'Баттлы',
    mechanicNameRushMid: 'Rush Mid',
    mechanicNameRoulette: 'Рулетка',
    mechanicNameUpgrade: 'Апгрейды',
    mechanicNameContract: 'Контракты',
    cashbackChipPrefix: 'кешбэк',
    cashbackChipLocked: 'кешбэк с {{level}} уровня',
    cashbackSpendButton: 'Потратить',
    cashbackInvestButton: 'Вложить',
    cashbackClaimReadyLabel: 'Кешбэк готов:',
    cashbackClaimButton: 'Забрать',
    cashbackTimerLabel: 'через',
    cashbackUnitDay: 'д',

    // BandStreak
    streakDayLabel: 'День {{day}} из 7',
    streakHint: 'Выполняй хотя бы одно задание в день {{days}} дней подряд — бонусом +',

    // BandShelfTeaser
    shelfTeaserTitle: 'Кейсы SHOT BAND',
    shelfTeaserAllCasesButton: 'Все кейсы',

    // BandFreeCases
    freeCasesTitle: 'Бесплатный кейс',
    freeCasesTurnoverLabel: 'Оборот сегодня',
    freeCasesNextHintPrefix: 'Ещё',
    freeCasesNextHintSuffix: 'оборота — и откроешь его бесплатно',
    freeCasesReadyHint: 'Можно открыть бесплатно — забирай!',
    freeCasesAllClaimed: 'Всё бесплатное на сегодня открыто — новые после сброса',
    freeCasesTimerBurnOpen: 'Не откроешь до сброса — сгорит',
    freeCasesTimerBurnProgress: 'Прогресс оборота сгорит через',
    freeCasesTimerPlain: 'До сброса дня',
    freeCasesTimerNew: 'Новые бесплатные открытия через',
    freeCasesOpenFreeButton: 'Открыть',
    freeCasesRulesTitle: 'Правила бесплатного кейса',
    freeCasesRulesWagerTitle: 'Играй за монеты',
    freeCasesRulesWagerBody: 'Любая игра за монеты идёт в дневной оборот — кейсы, битвы, апгрейды, контракты, Rush Mid, рулетка.',
    freeCasesRulesOpenTitle: 'Взял порог — открываешь бесплатно',
    freeCasesRulesOpenBody: 'У каждого кейса свой порог оборота. Добрался — клуб платит за открытие. Одно бесплатное открытие на кейс в день.',
    freeCasesRulesResetTitle: 'В полночь всё сгорает',
    freeCasesRulesResetBody: 'В полночь по Москве день обнуляется: прогресс оборота и невзятые бесплатные открытия сгорают. Новый день — с нуля.',

    // BandQuests
    questsTitle: 'Задания дня',
    questsResetLabel: 'Новые задания через',
    questClaimButton: 'Забрать',
    questsLockedJoinButton: 'Вступить',
    questGenericTitle: 'Ежедневное задание',
    questCompletedToastOverline: 'Задание выполнено!',
    questGenericUnit: '',

    quest_open_3_cases_2500_prefix: 'Открой 3 кейса от',
    quest_open_3_cases_2500_suffix: '',
    quest_open_3_cases_2500_unit: 'кейса',
    quest_rush_3_matches_prefix: 'Сыграй 3 матча в Rush Mid',
    quest_rush_3_matches_unit: 'матча',
    quest_open_band_case_prefix: 'Открой кейс SHOT BAND',
    quest_open_band_case_unit: 'кейс',
    quest_wager_25k_prefix: 'Прокрути',
    quest_wager_25k_suffix: '',
    quest_battles_2_5k_prefix: 'Сыграй 2 баттла со взносом от',
    quest_battles_2_5k_suffix: '',
    quest_battles_2_5k_unit: 'баттла',
    quest_upgrades_3_2500_prefix: 'Сделай 3 апгрейда от',
    quest_upgrades_3_2500_suffix: '',
    quest_upgrades_3_2500_unit: 'апгрейда',
    quest_contract_10k_prefix: 'Собери контракт от',
    quest_contract_10k_suffix: '',
    quest_contract_10k_unit: 'контракт',
    quest_win_battle_prefix: 'Выиграй баттл',
    quest_win_battle_unit: 'баттл',
    quest_win_upgrade_prefix: 'Выиграй апгрейд',
    quest_win_upgrade_unit: 'апгрейд',
    quest_open_case_12500_prefix: 'Открой кейс от',
    quest_open_case_12500_suffix: '',
    quest_open_case_12500_unit: 'кейс',
    quest_open_5_cases_1000_prefix: 'Открой 5 кейсов от',
    quest_open_5_cases_1000_suffix: '',
    quest_open_5_cases_1000_unit: 'кейсов',
    quest_roulette_play_prefix: 'Сыграй раунд рулетки',
    quest_roulette_play_unit: 'раунд',
    quest_contracts_25k_sum_prefix: 'Собери контрактов на',
    quest_contracts_25k_sum_suffix: '',
    quest_upgrades_15k_sum_prefix: 'Сделай апгрейдов на',
    quest_upgrades_15k_sum_suffix: '',
    quest_rush_5_matches_prefix: 'Сыграй 5 матчей Rush Mid',
    quest_rush_5_matches_unit: 'матчей',
    quest_wager_50k_prefix: 'Прокрути',
    quest_wager_50k_suffix: '',
    quest_wager_10k_battles_prefix: 'Прокрути',
    quest_wager_10k_battles_suffix: 'в баттлах',
    quest_wager_10k_rush_prefix: 'Прокрути',
    quest_wager_10k_rush_suffix: 'в Rush Mid',
    quest_wager_10k_roulette_prefix: 'Прокрути',
    quest_wager_10k_roulette_suffix: 'в рулетке',
    quest_wager_100k_prefix: 'Прокрути',
    quest_wager_100k_suffix: '',
    quest_rush_mid_win_prefix: 'Победи в Rush Mid',
    quest_rush_mid_win_unit: 'победа',
    quest_big_drop_25k_prefix: 'Выбей предмет дороже',
    quest_big_drop_25k_suffix: 'из кейса',
    quest_big_drop_25k_unit: 'предмет',
    quest_risky_upgrade_35_prefix: 'Выиграй апгрейд с шансом до 35%',
    quest_risky_upgrade_35_unit: 'апгрейд',
    quest_covert_drop_prefix: 'Выбей предмет Covert из кейса',
    quest_covert_drop_unit: 'предмет',

    // BandRaceSection
    raceTitle: 'Гонка дня',
    raceEmpty: 'Сегодня гонки нет — загляни позже',
    rulesLinkLabel: 'Правила',
    raceRulesTitle: 'Правила гонки дня',
    raceRulesPlayTitle: 'Как победить',
    raceRulesPlayBody: 'Играй во что угодно в SHOT — кейсы, апгрейды, контракты, баттлы, Rush Mid, рулетку. Считаются потраченные на игры монеты: у кого оборот за день больше всех — тот и победил.',
    raceRulesPrizeTitle: 'Приз',
    raceRulesPrizeBody: 'Каждый день — новый скин. В полночь по Москве он уходит первому месту и сразу падает в инвентарь.',
    raceRulesMembersTitle: 'Только для клуба',
    raceRulesMembersBody: 'Гонка — для членов SHOT BAND. Игра засчитывается автоматически, ничего включать не надо.',
    raffleRulesTitle: 'Правила розыгрыша недели',
    raffleRulesTicketsTitle: 'Получай билеты',
    raffleRulesTicketsBodyPrefix: 'Выполняй задания дня — за них дают билеты',
    raffleRulesTicketsBodySuffix: 'розыгрыша.',
    raffleRulesChanceTitle: 'Вкладывай и повышай шанс',
    raffleRulesChanceBody: 'Вкладывай билеты в раунд — чем больше вложил, тем выше шанс. Вложенное не возвращается, докидывать можно всегда.',
    raffleRulesFinalTitle: 'Финал',
    raffleRulesFinalBody: 'Раунд идёт неделю. Победителя выбирает случайность, скин сразу падает в инвентарь.',
    racePrizeLabel: 'Приз дня',
    raceYourPlace: 'Твоё место',
    raceParticipantsLabel: 'Участвует',
    raceNotWagered: 'Сыграй сегодня в любую игру — и ты в гонке',

    // BandRaffleSection
    raffleTitle: 'Розыгрыш недели',
    raffleEmpty: 'На этой неделе розыгрыша нет',
    raffleMyInvestedLabel: 'Вложено',
    raffleParticipantsLabel: 'Участвует',
    raffleParticipantOne: 'участник',
    raffleParticipantFew: 'участника',
    raffleParticipantMany: 'участников',
    raffleInvestButton: 'Вложить',
    raffleEndedButton: 'Раунд завершён',
    raffleWinnersLink: 'Победители',

    // BandInvestSheet
    investSheetTitle: 'Вклад в розыгрыш',
    investSheetLockedBody: 'Вступи в SHOT BAND, чтобы вкладывать в еженедельный розыгрыш.',
    investSheetJoinButton: 'Вступить',
    investSheetEndedBody: 'Этот раунд уже завершён — дождись следующего.',
    investSheetNoBalanceBody: 'Пока нечего вкладывать — выполняй задания дня, чтобы получить.',
    investSheetDecrease: 'Уменьшить',
    investSheetIncrease: 'Увеличить',
    investSheetBalanceHint: 'Доступно: {{balance}}',
    investSheetDisclaimer: 'Вложенное не возвращается — довложить можно в любой момент.',
    investSheetErrorGeneric: 'Не удалось вложить. Попробуй ещё раз.',
    investSheetSubmitButton: 'Вложить',
  },
  uz: {
    title: 'SHOT BAND',
    loading: 'SHOT BAND yuklanmoqda...',

    heroWelcome: 'Xush kelibsan',
    heroMemberBadge: 'SHOT BAND a\'zosi',
    heroDaysLeftOne: '{{count}} kun qoldi',
    heroDaysLeftFew: '{{count}} kun qoldi',
    heroDaysLeftMany: '{{count}} kun qoldi',
    heroDaysLeftZero: 'A\'zolik bugun tugaydi',
    heroRenewButton: 'Uzaytirish',
    heroOfferTitlePrefix: 'Hisob',
    heroOfferTitleSuffix: "ga to'ldirish klubni yoqadi — shu yerda ham, oddiy to'ldirishda ham.",
    heroOfferBody: '4% gacha keshbek — daraja bilan o\'sadi, kunlik topshiriqlar va pichoq lotereyasi.',
    heroOfferFinePrint: "Butun summa o'yin balansingga tushadi. Uni keyslarga, kontraktlarga, o'yinlarga va upgreydlarga xohlaganingcha sarflaysan.",
    heroJoinButton: "Qo'shilish —",
    heroHowItWorks: 'Bu qanday ishlaydi',

    rulesTitle: 'SHOT BAND qanday ishlaydi',
    rule1Prefix: 'Bir martalik',
    rule1Suffix: "to'lov bilan 28 kunga SHOT BAND'ga a'zo bo'lasan. Tangalar odatdagidek balansingga tushadi.",
    rule1Title: 'Klubga kirish',
    rule2Title: '4% gacha keshbek',
    rule2: "Tangaga har bir o'yin uchqunlar bilan keshbek qaytaradi. Foiz daraja bilan o'sadi — 10-darajada 1%, 100-darajada 4%. Har 7 kunda olib tur.",
    rule3Title: 'Uchqunga keyslar',
    rule3Prefix: 'Uchqunlar',
    rule3Suffix: "SHOT BAND keyslarini ochadi — ichida pichoqlargacha skinlar.",
    rule4Title: 'Topshiriqlar va strik',
    rule4Prefix: 'Kunlik topshiriqlar',
    rule4Mid: "beradi. 7 kunlik strikni saqla — bonus sifatida +10",
    rule4Suffix: '.',
    rule5Title: 'Pichoq lotereyasi',
    rule5Prefix: 'Har hafta pichoq o‘ynaymiz. O‘z',
    rule5Suffix: "laringni tik — bilet ko'p bo'lsa, imkoniyat yuqori.",
    rule6Title: 'Kun poygasi',
    rule6: "Yarim tungacha (MSK) tangaga eng ko'p o'ynagan kun skinini oladi. Har kuni yangi sovg'a.",
    rule7Title: 'Aylanma uchun bepul keyslar',
    rule7: "Kunlik aylanma keyslarni bepul ochadi — qancha ko'p o'ynasang, bepul keys shuncha qimmat. Har kuni, istalgan keysgacha.",

    ticketSheetTitleJoin: "SHOT BAND'ga qo'shilish",
    ticketSheetTitleRenew: 'SHOT BAND a\'zoligini uzaytirish',
    ticketSheetTopupNotePrefix: 'Balansingga darhol',
    ticketSheetTopupNoteSuffix: "tushadi — klub sovg'a sifatida beriladi.",
    ticketSheetRenewDisclaimer: "Uzaytirish joriy muddatga qo'shiladi — plyus 28 kun.",
    ticketSheetBuyButton: "To'lash",
    ticketSheetLoadingProviders: "To'lov usullari yuklanmoqda...",
    ticketSheetNoProviders: "Hozircha to'lov usullari mavjud emas.",
    ticketSheetErrorGeneric: "Hisob-fakturani yaratib bo'lmadi. Qayta urinib ko'r.",
    ticketSheetLoadErrorGeneric: "To'lov usullarini yuklab bo'lmadi.",
    ticketSheetPriceUnavailable: "Bu to'lov usuli uchun narx mavjud emas — boshqasini tanlang.",
    ticketSheetCardConfirmTitle: "To'lovni tasdiqla",
    ticketSheetCardConfirmMessage: "SHOT BAND'ga qo'shilish uchun {{card}} kartadan {{amount}} yechilsinmi?",
    ticketSheetCardConfirmOk: "To'lash",
    ticketSheetCardPending: "Click to'lovni hali tasdiqlamoqda — a'zolik avtomatik yoqiladi.",
    ticketSheetCardErrorGeneric: "To'lov o'tmadi. Qayta urinib ko'r.",

    cashbackBalanceLabel: 'Klub balansi',
    cashbackCoinsLabel: 'Uchqunlar',
    cashbackTicketsLabel: 'Chiptalar',
    cashbackNextPayoutLabel: "Keyingi to'lov:",
    mechanicNameCase: 'Keyslar',
    mechanicNameBattle: 'Battlar',
    mechanicNameRushMid: 'Rush Mid',
    mechanicNameRoulette: 'Ruletka',
    mechanicNameUpgrade: 'Apgreydlar',
    mechanicNameContract: 'Kontraktlar',
    cashbackChipPrefix: 'keshbek',
    cashbackChipLocked: 'keshbek {{level}}-darajadan',
    cashbackSpendButton: 'Sarflash',
    cashbackInvestButton: 'Tikish',
    cashbackClaimReadyLabel: 'Keshbek tayyor:',
    cashbackClaimButton: "Yig'ib olish",
    cashbackTimerLabel: 'ichida',
    cashbackUnitDay: 'kun',

    // BandStreak
    streakDayLabel: '{{day}}-kun / 7 kun',
    streakHint: "{{days}} kun ketma-ket kuniga kamida bitta topshiriq bajar — bonus +",

    // BandShelfTeaser
    shelfTeaserTitle: 'SHOT BAND keyslari',
    shelfTeaserAllCasesButton: 'Barcha keyslar',

    // BandFreeCases
    freeCasesTitle: 'Bepul keys',
    freeCasesTurnoverLabel: 'Bugungi aylanma',
    freeCasesNextHintPrefix: 'Yana',
    freeCasesNextHintSuffix: "aylanma — va uni bepul ochasan",
    freeCasesReadyHint: "Bepul ochish mumkin — oling!",
    freeCasesAllClaimed: "Bugungi barcha bepul ochishlar ishlatildi — yangilari yangilanishdan keyin",
    freeCasesTimerBurnOpen: "Ochmasang — yonib ketadi",
    freeCasesTimerBurnProgress: "Aylanma progressi yonib ketadi",
    freeCasesTimerPlain: 'Kun yangilanishigacha',
    freeCasesTimerNew: 'Yangi bepul ochishlar',
    freeCasesOpenFreeButton: 'Ochish',
    freeCasesRulesTitle: 'Bepul keys qoidalari',
    freeCasesRulesWagerTitle: "Tangaga o'yna",
    freeCasesRulesWagerBody: "Tangaga har qanday o'yin kunlik aylanmaga hisoblanadi — keyslar, janglar, upgreydlar, kontraktlar, Rush Mid, ruletka.",
    freeCasesRulesOpenTitle: 'Chegaraga yetding — bepul ochasan',
    freeCasesRulesOpenBody: "Har bir keysning o'z aylanma chegarasi bor. Yetib olding — ochish klub hisobidan. Har keysga kuniga bitta bepul ochish.",
    freeCasesRulesResetTitle: 'Yarim tunda hammasi yonadi',
    freeCasesRulesResetBody: "Moskva vaqti bilan yarim tunda kun yangilanadi: aylanma progressi va olinmagan bepul ochishlar yonib ketadi. Yangi kun — noldan.",

    // BandQuests
    questsTitle: 'Kunlik topshiriqlar',
    questsResetLabel: "Yangi topshiriqlargacha",
    questClaimButton: "Yig'ib olish",
    questsLockedJoinButton: "Qo'shilish",
    questGenericTitle: 'Kunlik topshiriq',
    questCompletedToastOverline: 'Topshiriq bajarildi!',
    questGenericUnit: '',

    quest_open_3_cases_2500_prefix: '',
    quest_open_3_cases_2500_suffix: "dan qimmat 3 ta keys och",
    quest_open_3_cases_2500_unit: 'keys',
    quest_rush_3_matches_prefix: "Rush Mid'da 3 ta matchda o'yna",
    quest_rush_3_matches_unit: 'match',
    quest_open_band_case_prefix: 'SHOT BAND keysini och',
    quest_open_band_case_unit: 'keys',
    quest_wager_25k_prefix: '',
    quest_wager_25k_suffix: ' aylantir',
    quest_battles_2_5k_prefix: "Kirish to'lovi",
    quest_battles_2_5k_suffix: "dan yuqori bo'lgan 2 ta jangda o'yna",
    quest_battles_2_5k_unit: 'jang',
    quest_upgrades_3_2500_prefix: '',
    quest_upgrades_3_2500_suffix: 'dan qimmat 3 ta apgreyd qil',
    quest_upgrades_3_2500_unit: 'apgreyd',
    quest_contract_10k_prefix: '',
    quest_contract_10k_suffix: 'dan qimmat kontrakt tuz',
    quest_contract_10k_unit: 'kontrakt',
    quest_win_battle_prefix: "Jangda g'alaba qozon",
    quest_win_battle_unit: 'jang',
    quest_win_upgrade_prefix: 'Apgreydda yutib chiq',
    quest_win_upgrade_unit: 'apgreyd',
    quest_open_case_12500_prefix: '',
    quest_open_case_12500_suffix: 'dan qimmat keys och',
    quest_open_case_12500_unit: 'keys',
    quest_open_5_cases_1000_prefix: '',
    quest_open_5_cases_1000_suffix: 'dan qimmat 5 ta keys och',
    quest_open_5_cases_1000_unit: 'keys',
    quest_roulette_play_prefix: "Ruletka turida o'yna",
    quest_roulette_play_unit: 'tur',
    quest_contracts_25k_sum_prefix: 'Jami',
    quest_contracts_25k_sum_suffix: 'lik kontraktlar tuz',
    quest_upgrades_15k_sum_prefix: 'Jami',
    quest_upgrades_15k_sum_suffix: 'lik apgreydlar qil',
    quest_rush_5_matches_prefix: "Rush Mid'da 5 ta matchda o'yna",
    quest_rush_5_matches_unit: 'match',
    quest_wager_50k_prefix: '',
    quest_wager_50k_suffix: ' aylantir',
    quest_wager_10k_battles_prefix: 'Janglarda',
    quest_wager_10k_battles_suffix: ' aylantir',
    quest_wager_10k_rush_prefix: "Rush Mid'da",
    quest_wager_10k_rush_suffix: ' aylantir',
    quest_wager_10k_roulette_prefix: 'Ruletkada',
    quest_wager_10k_roulette_suffix: ' aylantir',
    quest_wager_100k_prefix: '',
    quest_wager_100k_suffix: ' aylantir',
    quest_rush_mid_win_prefix: "Rush Mid'da g'alaba qozon",
    quest_rush_mid_win_unit: "g'alaba",
    quest_big_drop_25k_prefix: 'Keysdan',
    quest_big_drop_25k_suffix: 'dan qimmat buyum tushir',
    quest_big_drop_25k_unit: 'buyum',
    quest_risky_upgrade_35_prefix: "Ehtimolligi 35% gacha bo'lgan apgreydda yutib chiq",
    quest_risky_upgrade_35_unit: 'apgreyd',
    quest_covert_drop_prefix: 'Keysdan Covert buyum tushir',
    quest_covert_drop_unit: 'buyum',

    // BandRaceSection
    raceTitle: 'Kunlik poyga',
    raceEmpty: "Bugun poyga yo'q — keyinroq kir",
    rulesLinkLabel: 'Qoidalar',
    raceRulesTitle: 'Kunlik poyga qoidalari',
    raceRulesPlayTitle: "Qanday g'alaba qozonish",
    raceRulesPlayBody: "SHOT'da istalgan o'yinni o'yna — keyslar, apgreydlar, kontraktlar, janglar, Rush Mid, ruletka. O'yinlarga sarflangan tangalar hisoblanadi: kunlik aylanmasi eng katta bo'lgan yutadi.",
    raceRulesPrizeTitle: "Sovg'a",
    raceRulesPrizeBody: "Har kuni yangi skin. Yarim tunda (MSK) u birinchi o'ringa beriladi va darhol inventarga tushadi.",
    raceRulesMembersTitle: "Faqat klub uchun",
    raceRulesMembersBody: "Poyga — SHOT BAND a'zolari uchun. O'yin avtomatik hisoblanadi, hech narsani yoqish shart emas.",
    raffleRulesTitle: 'Haftalik lotereya qoidalari',
    raffleRulesTicketsTitle: 'Chiptalarni yig',
    raffleRulesTicketsBodyPrefix: 'Kunlik topshiriqlarni bajar — ular uchun lotereya chiptalari',
    raffleRulesTicketsBodySuffix: 'beriladi.',
    raffleRulesChanceTitle: 'Qo\'y va imkoniyatni oshir',
    raffleRulesChanceBody: "Chiptalarni turga qo'y — qancha ko'p qo'ysang, imkoniyat shuncha yuqori. Qo'yilganlar qaytarilmaydi, yana qo'shish mumkin.",
    raffleRulesFinalTitle: 'Final',
    raffleRulesFinalBody: "Tur bir hafta davom etadi. G'olibni tasodif tanlaydi, skin darhol inventarga tushadi.",
    racePrizeLabel: "Kun sovg'asi",
    raceYourPlace: "Sening o'rning",
    raceParticipantsLabel: 'Ishtirok etyapti',
    raceNotWagered: "Bugun istalgan o'yinni o'yna — va sen poygadasan",

    // BandRaffleSection
    raffleTitle: 'Haftalik lotereya',
    raffleEmpty: "Bu hafta lotereya yo'q",
    raffleMyInvestedLabel: "Qo'yilgan",
    raffleParticipantsLabel: 'Ishtirok etyapti',
    raffleParticipantOne: 'ishtirokchi',
    raffleParticipantFew: 'ishtirokchi',
    raffleParticipantMany: 'ishtirokchi',
    raffleInvestButton: "Qo'yish",
    raffleEndedButton: 'Tur tugadi',
    raffleWinnersLink: "G'oliblar",

    // BandInvestSheet
    investSheetTitle: "Lotereyaga qo'yish",
    investSheetLockedBody: "Haftalik lotereyaga qo'yish uchun SHOT BAND'ga qo'shil.",
    investSheetJoinButton: "Qo'shilish",
    investSheetEndedBody: 'Bu tur allaqachon tugadi — keyingisini kut.',
    investSheetNoBalanceBody: "Hozircha qo'yadigan narsa yo'q — kunlik topshiriqlarni bajarib ol.",
    investSheetDecrease: 'Kamaytirish',
    investSheetIncrease: 'Oshirish',
    investSheetBalanceHint: 'Mavjud: {{balance}}',
    investSheetDisclaimer: "Qo'yilganlar qaytarilmaydi — istalgan payt yana qo'shishing mumkin.",
    investSheetErrorGeneric: "Qo'yib bo'lmadi. Qayta urinib ko'r.",
    investSheetSubmitButton: "Qo'yish",
  },
});
